module.exports = __webpack_public_path__ + "img/ex-login.a4e58d98.jpg";